import { useState, useEffect } from "react";
import "../App.css"
import { Box, Typography } from '@mui/material'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

function Stepper({ activePages }: { activePages: string[] }) {
    const [active, setActive] = useState(activePages);

    useEffect(() => {
        setActive(activePages);
    }, [activePages]);

    return (
        <Box className="stepper-container" >
            <ul className="multistep-form">
                <li className={active.includes("verification") ? "active" : ""}>
                    <span className="step-icon">
                        <GppGoodOutlinedIcon />
                    </span>
                    <Typography >التحقق<br/> Verification
                    </Typography>
                </li>
                <li className={active.includes("deals") ? "active" : ""}>
                    <span className="step-icon">
                        <ShoppingBagOutlinedIcon />
                    </span>
                    <Typography >المعاملات<br/> Deals</Typography>
                </li>
                <li className={active.includes("installments") ? "active" : ""}>
                    <span className="step-icon">
                        <RequestQuoteOutlinedIcon />
                    </span>
                    <Typography >الأقساط<br/> Installments</Typography>
                </li>
                <li className={active.includes("payment") ? "active" : ""}>
                    <span className="step-icon">
                        <CreditCardOutlinedIcon />
                    </span>
                    <Typography >الدفع<br/> Payment</Typography>
                </li>
            </ul>
        </Box>
    )
}

export default Stepper